module.exports = __webpack_public_path__ + "img/propose-illustration.b74c398e.svg";